import Tracker from './Tracker'

class GoogleAnalytics extends Tracker {
  ecommerceLoaded = false

  async init () {
    /* istanbul ignore next */
    /* eslint-disable no-unused-expressions, no-sequences */
    !(function (i, s, o, g, r, a, m) {
      if (i[r]) return
      i['GoogleAnalyticsObject'] = r
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
      (i[r].l = 1 * new Date())
      ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(
      window,
      document,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga'
    )
    /* eslint-enable no-unused-expressions */
  }

  event (event, firstLoad, ...args) {
    if (event === 'success' && !this.ecommerceLoaded) {
      const { trackerName } = this.props
      window.ga(
        `${(trackerName && trackerName + '.') || ''}require`,
        'ecommerce'
      )
      this.ecommerceLoaded = true
    }

    window.ga(...args)
  }
}

export default GoogleAnalytics
